import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormGroup, FormControl, NgForm } from "@angular/forms";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ProductService } from "src/core/services/product.service";
import { EditDataComponent } from "../modals/edit-data/edit-data.component";
import { ViewDataComponent } from "../modals/view-data/view-data.component";
import { Form } from "../../../../api/models/form";
import {FormFilter, FormState, FormType} from "../../../../api/models";
import { FilingService } from "../../../../api/services/filing.service";
import { ConfirmationService, MessageService } from "primeng/api";
import { Subscription } from "rxjs";
import { FilingCommunicationService } from "../sharedServices/filing-communication.service";
import { ProcessedViewComponent } from "../modals/processed-view/processed-view.component";
import { ProcessedEditComponent } from "../modals/processed-edit/processed-edit.component";
import { DiscardConfirmationComponent } from "../modals/discard-confirmation/discard-confirmation.component";
import { PreviousFilingIdService } from "src/core/services/shared/filingId.service";
import { handlePasteWithoutLeadingSpaces, preventLeadingSpaceKey } from "src/core/utils/input-validation.utils";

@Component({
  selector: "app-processed",
  templateUrl: "./processed.component.html",
  styleUrl: "./processed.component.css",
  standalone: false,
})
export class ProcessedComponent implements OnInit, OnDestroy {
  private reloadSubscription?: Subscription;
  filings: Form[] = [];
  selectedProducts: any[] = [];
  first = 0;
  rows = 10;
  displayViewModal = false;
  displayEditModal = false;
  isLoading: boolean = false;
  ref!: DynamicDialogRef;
  formTypes = FormType.values();
  formStates = FormState.values().filter(
    type => type === FormState.PROCESSED || type === FormState.DUPLICATE
  );
  selectedFormType: FormType | undefined;
  selectedFormState: FormState = FormState.PROCESSED;
  @Input() filingIdInput?: number;
   @Input() filingStateInput?: FormState | string;

  usersList: string[] = [];
  selectedByAnalyst?: string;
  // filingIdInput?: number;
  issuerNameInput?: string;
  selectedPlan: any[] = [];
  rangeDates: Date[] | undefined;
  startDateInput?: Date | string;
  endDateInput?: Date | string;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  constructor(
    private _filingService: FilingService,
    private dialogService: DialogService,
    private _messageService: MessageService,
    private filingCommService: FilingCommunicationService,
    private _confirmationService: ConfirmationService,
    private previousFilingIdService: PreviousFilingIdService
  ) {}

  ngOnInit(): void {
      //  apply state from input
  if (this.filingStateInput) {
    const state = String(this.filingStateInput).toUpperCase();

    if (state === FormState.DUPLICATE) {
      this.selectedFormState = FormState.DUPLICATE;
    } else if (state === FormState.PROCESSED) {
      this.selectedFormState = FormState.PROCESSED;
    }
  }

    this.getUserList();
    this.reloadSubscription = this.filingCommService.reloadProcessed$.subscribe(
      () => {
        this.getFilingWithFilingFilter();
      }
    );
  }
  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  isLastPage(): boolean {
    return this.filings ? this.first + this.rows >= this.filings.length : true;
  }

  isFirstPage(): boolean {
    return this.filings ? this.first === 0 : true;
  }

  openEditModal(filing: Form) {
    this.ref = this.dialogService.open(ProcessedEditComponent, {
      dismissableMask: false,
      closable: true,
      modal: true,
      showHeader: true,
      style: { width: "80vw", height: "100vh", top: "0", left: "0" },
      contentStyle: { overflow: "auto", height: "calc(100vh - 5rem)" },
      baseZIndex: 10000,
      maximizable: true,
      data: {
        filing,
        selectedPlan: this.selectedPlan,
      },
    });

    this.ref.onClose.subscribe({
      next: (data) => {
        this.selectedPlan = [];

        if (data?.refresh) {
          this.getFilingWithFilingFilter();
        } else {
          const filingId = filing?.filingId;
          if (filingId) {
            this.openViewModal(filingId, new MouseEvent("click")); // Dummy event pass kiya
          }
        }
      },
    });
  }

  openViewModal(filingId: number, event: Event) {
    event.preventDefault();
    if (filingId && filingId !== undefined) {
      this.previousFilingIdService.setPreviousFiling(
        filingId.toString(),
        "PROCESSED"
      );
    }
    this.isLoading = true;
    this._filingService.getFilingByFilingId(filingId).subscribe({
      next: (filing) => {
        this.ref = this.dialogService.open(ProcessedViewComponent, {
          dismissableMask: false,
          closable: true,
          modal: true,
          showHeader: true,
          // Simulate maximized view
          style: {
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            maxHeight: "100vh",
            padding: "0",
            margin: "0",
            borderRadius: "0",
          },

          // Adjust internal scrolling content
          contentStyle: {
            height: "calc(100vh - 4rem)",
            overflow: "auto",
          },

          baseZIndex: 10000,
          // maximizable: true,
          data: {
            filing: filing,
          },
        });
        this.ref.onClose.subscribe({
          next: (data) => {
            if (!data) {
              this.getFilingWithFilingFilter()
              return;
            }
            if (data?.refresh) {
              this.getFilingWithFilingFilter();
            }
            else if (data) {
              this.selectedPlan = data;
              this.openEditModal(filing);
            }
          },
        });
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }


  onDateChange() {
    if (this.rangeDates && this.rangeDates.length === 2) {
      const formatDate = (date: Date) => date.toLocaleDateString("en-CA"); // yyyy-mm-dd (local)

      this.startDateInput = formatDate(this.rangeDates[0]);
      this.endDateInput = formatDate(this.rangeDates[1]);

      this.onSearch();
    } else {
      this.startDateInput = undefined;
      this.endDateInput = undefined;
      this.onSearch();
    }
  }
onSearch(form?: NgForm) {
  if (form && form.invalid) {
    form.control.markAllAsTouched();
    return;
  }

  this.first = 0;
  this.paginator.pageNumber = 1;
  this.getFilingWithFilingFilter();
}


  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getFilingWithFilingFilter();
  }

  getUserList() {
    this.isLoading = true;
    this._filingService.getUserList().subscribe({
      next: (value) => {
        this.usersList = value;
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }
  getFilingWithFilingFilter() {
        const cleanedIssuerName =
    typeof this.issuerNameInput === 'string'
      ? this.issuerNameInput.trim()
      : this.issuerNameInput;
    const params: FormFilter = {
      formState: this.selectedFormState ?? FormState.PROCESSED,
      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      formType: this.selectedFormType,
      filingId: this.filingIdInput,
      issuerName:cleanedIssuerName,
      analyst: this.selectedByAnalyst,
      startDate:
        this.startDateInput instanceof Date
          ? this.startDateInput.toISOString()
          : this.startDateInput,
      endDate:
        this.endDateInput instanceof Date
          ? this.endDateInput.toISOString()
          : this.endDateInput,
    };
    this.isLoading = true;
    this._filingService.getFilings(params).subscribe({
      next: (value) => {
        this.filings = value;
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.filings.length > 0 ? this.filings[0].totalCount! : 0;
        this.isLoading = false;
      },
    });
  }

  ngOnDestroy(): void {
    this.reloadSubscription?.unsubscribe();
  }
   preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }
onPaste(
  event: ClipboardEvent,
  field: "issuerNameInput" | "filingIdInput"
): void {
  handlePasteWithoutLeadingSpaces(event, (newValue: string) => {

    if (field === "issuerNameInput") {
      this.issuerNameInput = newValue.trim() || undefined;
      return;
    }

    if (field === "filingIdInput") {
      const num = Number(newValue.trim());
      this.filingIdInput = Number.isNaN(num) ? undefined : num;
    }

  });
}
}
